
import { message } from "antd";
import FormHelpers from "../../../../helpers/FormHelpers";

const ERROR_MESSAGES = {
  requiredField: (fieldName) => `Error in ${fieldName} field. Select/Enter a valid value then proceed.`,
};

const validateDocLevel = ({
  cfManufacturingOrderDoc, deliveryDate, scheduledDate, sellerId
}) => {
  const errors = [];
  if (!deliveryDate) {
    errors.push({
      name: "Completion Date",
      value: "",
      message: ERROR_MESSAGES.requiredField("Completion Date"),
    });
  }

  if (!scheduledDate) {
    errors.push({
      name: "Scheduled Start Date",
      value: "",
      message: ERROR_MESSAGES.requiredField("Scheduled Start Date"),
    });
  }

  if (cfManufacturingOrderDoc) {
    cfManufacturingOrderDoc.forEach((field) => {
      if (field.isRequired && field?.isActive) {
        errors.push({
          name: field?.fieldName,
          value: field?.fieldValue,
          message: ERROR_MESSAGES.requiredField(field?.fieldName),
        });
      }
    });
  }

  return errors;
};

const validateLineLevel = ({ finishedGoods, bomLines, bomByProducts, restrictMoUser, moUsers, extraCharges, trackWastage }) => {
  const errors = [];
  if (finishedGoods?.length === 1 && !finishedGoods[0]?.tenant_product_info
  ) {
    errors.push({
      name: "Finished Goods",
      value: 0,
      message: "Error in Finished Goods. Select a Finished Good to continue.",
    });
  } else {
    for (let i = 0; i < finishedGoods?.length; i++) {
      if (!finishedGoods[i]?.quantity || finishedGoods[i]?.quantity <= 0) {
        errors.push({
          name: "Finished Goods Quantity",
          value: 0,
          message: ERROR_MESSAGES.requiredField(`Quantity for Product '${finishedGoods[i]?.tenant_product_info?.internal_sku_code || ""}' (Finished Goods Tab)`),
        });
      }
      if (finishedGoods[i]?.lineCustomFields) {
        const lineCustomFields = finishedGoods[i]?.lineCustomFields;
        lineCustomFields.forEach((field) => {
          if (field.isRequired && field?.isActive) {
            errors.push({
              name: field?.fieldName,
              value: field?.fieldValue,
              message: ERROR_MESSAGES.requiredField(`${field?.fieldName} for Product '${finishedGoods[i]?.tenant_product_info?.internal_sku_code || ""}' (Finished Goods Tab)`),
            });
          }
        });
      }
    }
    if (bomLines) {
      const bomLineArray = Object.values(bomLines).flat();
      for (let i = 0; i < bomLineArray?.length; i++) {
        const bomLine = bomLineArray[i];
        if (!bomLine?.estimatedUsage || Number(bomLine?.estimatedUsage) <= 0) {
          errors.push({
            name: "Estimated Usage",
            value: 0,
            message: ERROR_MESSAGES.requiredField(`Estimated Usage for Product '${bomLineArray[i]?.tenant_product_info?.internal_sku_code || ""} (Raw Materials Tab)`),
          });
        }
        // if (bomLineArray[i]?.lineCustomFields) {
        //   const lineCustomFields = bomLineArray[i]?.lineCustomFields;
        //   lineCustomFields.forEach((field) => {
        //     if (field.isRequired && field?.isActive) {
        //       errors.push({
        //         name: field?.fieldName,
        //         value: field?.fieldValue,
        //         message: ERROR_MESSAGES.requiredField(`${field?.fieldName} for Product '${bomLineArray[i]?.tenant_product_info?.internal_sku_code || ""}' (Raw Materials Tab)`),
        //       });
        //     }
        //   });
        // }
      }
    }
    if (bomByProducts) {
      const byProductsLineArray = Object.values(bomByProducts).flat();
      if (byProductsLineArray?.filter((item) => item?.tenantProductId)?.length >= 1) {
        for (let i = 0; i < byProductsLineArray?.length; i++) {
          if ((!byProductsLineArray[i]?.estimatedUsage || Number(byProductsLineArray[i]?.estimatedUsage) <= 0) &&byProductsLineArray[i]?.product_info) {
            errors.push({
              name: "Estimated Usage",
              value: 0,
              message: ERROR_MESSAGES.requiredField(`Estimated Production for Product '${byProductsLineArray[i]?.tenant_product_info?.internal_sku_code || ""}' (By Products Tab)`),
            });
          }
          if (!byProductsLineArray[i]?.product_info) {
            errors.push({
              name: "By Product",
              value: 0,
              message: "Error in By Products. Select a By Product or remove the line (By Products Tab) to continue.",
            });
          }
        }
      }
    }
    if (restrictMoUser) {
      if (moUsers?.length <= 0) {
        errors.push({
          name: "Finished Goods",
          value: 0,
          message: "Missing Authorized Users.",
        });
      }
    }
    if (extraCharges) {
      const extraChargesLineArray = Object.values(extraCharges).flat();
      for (let i = 0; i < extraChargesLineArray?.length; i++) {
        if ((extraChargesLineArray[i]?.charge_amount?.toString() === '') || (Number(extraChargesLineArray[i]?.charge_amount) < 0)) {
          errors.push({
            name: "Charge Amount",
            value: 0,
            message:`Pleaser Enter a Valid Charge Amount for the ${extraChargesLineArray[i]?.charge_name} to continue`,
          });
        }
      }
    }
  }

  return errors;
};

const moerrorsList = (params) => {
  const docLevelErrors = validateDocLevel(params);
  const lineLevelErrors = validateLineLevel(params);
  
  return FormHelpers.errorChecker({ docLevelErrors, lineLevelErrors });
};

export default moerrorsList;